var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":_vm.title,"doc":_vm.doc}},[_c('div',{staticClass:"body-2"},[_vm._v("Only use this to manage multiple businesses with same menus, hours, or settings.")]),_c('div',{staticClass:"subtitle-2 warning--text"},[_vm._v("This action can't be undone.")]),_c('Table'),_c('Backup'),_c('ThirdParty',{staticClass:"my-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }